import Auth from "../../utils/auth";
import {Link, Navigate} from "react-router-dom";
import Nav from "../../components/Nav";
import React from "react";
import {isDateXDaysBeforeToday, timeConverter} from "../../utils/timeConverter";
import {GET_USER_SIGNUPS_ON_CLICK} from "../signups/gql/queries";
import {useQuery} from "@apollo/client";
import SectionHeader from "../../components/SectionHeader";
import AllergenIcon from "../../components/AllergenIcon";

const History = () => {

    const { loading: userSignupsLoading, data: getUserSignupsData } = useQuery(GET_USER_SIGNUPS_ON_CLICK, { variables: { number: "250" } });
    let userSignupsData = getUserSignupsData?.userSignupsOnClick || [];

    return (
        <>
            <div className="navAndHeader">
                <Nav />
            </div>
            <div className="mainContainer">
                <h1>History</h1>
                <SectionHeader title="Signups" className='sectionHeader' />
                <div className='dishContainer'>
                    {
                        userSignupsData && userSignupsData
                            .filter((signup) => isDateXDaysBeforeToday(signup.menuItem?.menuDate, 14))
                            .sort((a, b) => b.menuItem?.menuDate - a.menuItem?.menuDate)
                            .map((signup) => (
                                <div key={signup._id}>
                                    <div className="signupHistoryRow">
                                        <p>{timeConverter(signup.menuItem?.menuDate)}</p>
                                        <div className="dishNameWithAllergens">
                                            <p>{signup.menuItem?.dish?.dishName}</p>
                                            <AllergenIcon
                                                allergens={signup.menuItem?.dish?.allergens}
                                                calories={signup.menuItem?.dish?.calories}
                                            />
                                        </div>
                                        <p>{signup.size}</p>
                                        <Link to={`/feedback/${signup.menuItem._id}`} style={{ textDecoration: "none", display: 'flex', justifyContent: 'center' }}>
                                            <button className='submitButton feedbackButton'><p>Feedback</p></button>
                                        </Link>
                                    </div>
                                    <hr className="dishRowLine" />
                                </div>
                            ))}
                </div>
            </div>
        </>);
}

export default History;
